<script lang="ts">
    import ProjectsList from "../widgets/ProjectsList.svelte"
    import Header from "../widgets/Header.svelte"

    export let content: Content // Current page content
</script>

<Header type="{1}" />

{#if content}
    <main class="page {content?.type?.join(' ').toLowerCase()}">
        <section class="wm-container">
            <ProjectsList content="{content}" />
        </section>
    </main>
{/if}
